import { render, staticRenderFns } from "./size-chart.vue?vue&type=template&id=f6121b4a"
import script from "./size-chart.vue?vue&type=script&lang=js"
export * from "./size-chart.vue?vue&type=script&lang=js"
import style0 from "./size-chart.vue?vue&type=style&index=0&id=f6121b4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports